import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Select, { components } from 'react-select';
import theme from '../../../themes/CBB/theme';

const useStyles = makeStyles((theme: any) => ({
  root: {
    backgroundColor: theme.palette.brand.greyLight,
    borderRadius: theme.spacing(4),
    marginBottom: theme.spacing(1),
    color: theme.palette.brand.greenDark,
  },
  dropDownIcon: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    '& .MuiAvatar-img': {
      height: 'auto',
      width: 'auto',
    },
  },
}));

export default function StyledSelectBlock({
  defaultValue,
  dropDownIconPath,
  CustomOption,
  options,
  onChange,
  className = '',
  children = null,
  disable = false,
  ...rest
}) {
  const classes = useStyles();

  const customStyles = {
    dropdownIndicator: (base) => ({
      ...base,
      curser: 'pointer',
    }),
    control: (base) => ({
      ...base,
      background: theme.palette['brand'].greyLight,
      borderRadius: 12,
      border: 0,
      curser: 'pointer',
      '&:hover': {
        backgroundColor: '#C2CFE0',
      },
    }),
    valueContainer: (base) => ({
      ...base,
      justifyContent: 'center',
      cursor: 'pointer',
    }),
    menu: (base) => ({
      ...base,
      marginTop: 0,
      borderRadius: 12,
      cursor: 'pointer',
    }),
    menuList: (base) => ({
      ...base,
      borderRadius: 12,
      cursor: 'pointer',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#C2CFE0' : '',
      color: 'black',
      cursor: 'pointer',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  const dropDownIcon = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <Avatar src={dropDownIconPath} className={classes.dropDownIcon} />
      </components.DropdownIndicator>
    );
  };

  return (
    <div className={classes.root + ' ' + className}>
      <Select
        {...rest}
        components={{ Option: CustomOption, DropdownIndicator: dropDownIcon }}
        options={options}
        styles={customStyles}
        isSearchable={false}
        isDisabled={disable}
        onChange={(selected) => {
          onChange(selected);
          return { value: selected, label: selected };
        }}
        defaultValue={{ label: defaultValue }}
      >
        {children}
      </Select>
    </div>
  );
}
